import { num, object, oneOf, str, type FieldParser } from 'validation';

// The retention types (canonical runtime list); `RetentionType` derives from it,
// so the two can't drift and the list is asserted complete (adding a type is a
// one-line change here).
export const RETENTION_TYPES = ['minutes_to_keep', 'days_to_keep', 'months_to_keep', 'executions_to_keep'] as const;
export type RetentionType = (typeof RETENTION_TYPES)[number];

// One retention rule. The backend stores `retention_policies` as a pass-through
// JSONB array with no item validation, on BOTH `zones` and `node_definitions`
// (migration 0110) — the shape is the contract enforced by the retention cron
// job (nap-backend cron-jobs/retention-policies-job.js + retentionPolicyRules.js).
//
// Shared here by IDENTITY: one shape, carried by every resource that has the
// column, imported wherever it's needed (like `folderPath`). `status` is 'all'
// (wildcard) or a node-instance status — a plain string, since the backend
// lowercases and groups freely.
export interface RetentionPolicy {
  readonly status: string;
  readonly retention_type: RetentionType;
  readonly value: number;
}

export const retentionPolicySchema: FieldParser<RetentionPolicy> = object<RetentionPolicy>({
  status: str(),
  retention_type: oneOf(RETENTION_TYPES, 'days_to_keep'),
  value: num(),
});
